import request from '../../axios';

const PostFertilizerRequirement = async (
  payload: IFertilizerRequirementPayload,
) => {
  const newPayload = {
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    ad_type: payload.ad_type,
    wanted_weight: payload.wanted_weight,
    weight_unit: payload?.weight_unit?.value,
    brs_type: payload.srs_type?.type,
    only_massage_buyer: payload.only_massage_buyer || false,
    type: payload?.type?.value,
    is_change_title: payload?.is_change_title,
  };
  const res = await request.post(`api/v2/wanted/fertilizer-requirement`, {
    ...newPayload,
  });

  return res.data;
};

export default PostFertilizerRequirement;
